import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQ_ITEMS = [
  {
    q: "Can you work with our existing codebase?",
    a: "Yes. Existing systems are audited first, then a phased plan is created for stabilization, improvements, and new feature delivery. Legacy constraints, architecture quality, and release risk are handled before acceleration.",
  },
  {
    q: "Do you work with non-technical founders?",
    a: "Yes. Non-technical teams receive structured guidance across scope, roadmap, milestones, and delivery decisions. Communication stays clear, decision-ready, and business-focused throughout the build.",
  },
  {
    q: "What happens post-launch?",
    a: "Post-launch support includes monitoring, performance optimization, bug resolution, and iterative feature releases. The product is supported as a system, not handed off and abandoned after deployment.",
  },
  {
    q: "Can software, AI, hardware, and 3D be delivered together?",
    a: "Yes. Cross-discipline delivery is a core model: interface, backend, AI workflows, firmware, and enclosure development are managed as one integrated system to eliminate context loss.",
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="relative py-24 md:py-28 border-y border-white/5" data-testid="faq-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-zinc-500 mb-4">
            / 08 — FAQ
          </div>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight" data-testid="faq-heading">
            Common questions.
            <br />
            <span className="text-zinc-500">Clear answers.</span>
          </h2>
          <p className="mt-6 text-zinc-400 max-w-2xl text-base md:text-lg leading-relaxed">
            Answers to the most common objections before kickoff — from working with
            existing codebases to post-launch ownership.
          </p>
        </div>

        <div className="space-y-3">
          {FAQ_ITEMS.map((item, i) => {
            const open = openIdx === i;
            return (
              <article
                key={item.q}
                className="glass-card rounded-2xl border border-white/10 overflow-hidden"
                data-testid={`faq-item-${i}`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 text-left px-5 sm:px-7 py-5 sm:py-6"
                  aria-expanded={open}
                >
                  <span className="font-display text-lg sm:text-xl text-white leading-snug">
                    {item.q}
                  </span>
                  <ChevronDown
                    size={18}
                    className={`text-zinc-400 transition-transform ${open ? "rotate-180" : ""}`}
                  />
                </button>
                <div
                  className={`grid transition-all duration-300 ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 sm:px-7 pb-5 sm:pb-6 text-zinc-400 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
